import React from 'react';

import { ModalEntryPoint } from '../shared/modal-entry-point';
import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './userLimitDirectBuyModal.entrypoint';

const entryPointParams = {};
const modalProps = { width: 968, height: 560 };

export function UserLimitDirectBuyModal(): React.JSX.Element {
	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			modalProps={modalProps}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
